import { Observable } from 'rxjs';

import { SnLonLat, SnLonLatBounds } from '@lib/geo/helpers';

export interface IFsMap {
  // Core map properties
  readonly geospatialProvider: string;
  readonly id: string;

  // Map state
  getZoom(): number;
  setZoom(zoom: number): void;
  getCenter(): SnLonLat;
  setCenter(coords: SnLonLat | { lng: number; lat: number }): void;
  getBounds(): SnLonLatBounds;

  // Map style and appearance
  setStyle(style: string): void;
  getStyle(): string;
  setOptions(options: any): void;

  // Navigation
  panTo(coords: SnLonLat | { lng: number; lat: number }): void;
  setHeading(heading: number): void;

  // Events
  on(event: string): Observable<any>;

  // Layer management
  addMarker(marker: any): void;
  removeMarker(marker: any): void;
  addLayer(layer: any): void;
  removeLayer(layer: any): void;

  // Utility methods
  setMapId(mapId: string): void;
  removeLayers(): void;
}
